<template>
  <section class="header_main font-responsive">
    <div v-if="!component_data.params.display" class="header_kv w-full r-8/3">
      <img :src="component_data.params.img.src" :alt="component_data.params.img.alt" />
    </div>
    <div class="header_content mobile-sides">
      <div class="header_copy w-2/5 mobile:w-full">
        <h2 v-html="component_data.params.title"></h2>
        <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
      </div>
    <div class="header_media w-2/5 r-2/1" :class="{noHeaderFoto:component_data.params.display}">
        <video-block
          class="feat_video"
          v-if="component_data.params.vid"
          :component_data="component_data.params.vid"
        ></video-block>
        <img v-else :src="component_data.params.img_2.src" :alt="component_data.params.img_2.alt" />
      </div>
    </div>
  </section>
</template>

<script>
import video from "@/components/videoBlock/video";
export default {
  props: ["component_data"],
  components: {
    "video-block": video
  }
};
</script>

<style scoped>
.noHeaderFoto{
  margin-top:8rem;
}
.header_kv,
.header_media {
  position: relative;
}

.header_kv img,
.header_media img,
.feat_video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
}

.header_media img,
.feat_video {
  transform: translateX(-20%) translateY(-6em);
}

.header_media::before {
  background: linear-gradient(to right, #ae0b11, #e41429);
  border-bottom-left-radius: 6em;
}

.header_media img,
.feat_video {
  border-top-left-radius: 6em;
  overflow: hidden;
}

.header_content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 8.33%;
}

.header_main {
  /* margin-bottom: 2.8em; */
  background: #fff;
  position: relative;
  z-index: 2;
  border-bottom: #fff 2.8em solid;
}
.header_main h2 {
  font-weight: 400;
  line-height: 1.41em;
  font-size: 4.8em;
  margin: 0 0 0.8em 0;
}
.header_main p {
  font-size: 2em;
  line-height: 1.9em;
  margin: 0.4em 0;
}

.header_copy {
  padding-top: 8em;
}

@media (max-width: 992px) {
  .header_media {
    display: none;
  }
  .header_content {
    margin-left: 0;
  }
}
</style>

<style>
.bakingprosystem-logo svg {
  height: 1.2em;
  margin-top: -0.22em;
  fill: currentColor;
}
</style>